import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent'

import InputLabel from '@material-ui/core/InputLabel';
import Select from 'react-select';

import Grid from '@material-ui/core/Grid';

//validators
import {validateField} from '../common/redux/validators';

import{ CREATE_PROJECT_MODEL_ACTION_CREATE } from '../common/redux/constantes';

export class SelectDeliverable extends Component {
  static propTypes = {
    ca: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  constructor(props){
    super(props);

    this.state = {
      assignation:{control_account: this.props.ca.control_account},
      errores:{},
      buttonDisabled:false
    }

    //bindings
    this.selectDeiverables = this.selectDeiverables.bind(this);
    this.onEnter = this.onEnter.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeSelection = this.handleChangeSelection.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  selectDeiverables()
  {
    //Solo puede guardar si está valido el form
    if(!this.validateForm())
    {
      return;
    }
    this.setState({buttonDisabled:true});

    //Vamos a editar/crear Component
    this.props.actions.saveDeliverableAssignation(this.state.assignation,CREATE_PROJECT_MODEL_ACTION_CREATE)
    .then(res=>{
      this.handleClose();
    });

  }

  onEnter()
  {
    //Consultar los deliverables disponibles
    this.props.actions.fetchDeliverablesAvailable(this.props.caSelected.project)
    .then(res=>{

      if(res.data.deliverables && res.data.deliverables.length>0)
      {
        let deliverables = res.data.deliverables.map(deliverable=>{
          let del = {};
          del.deliverable = del.value = deliverable.deliverable;
          del.name = del.label= deliverable.name;
          return del;
        })

        let assignation = this.state.assignation;
        assignation.control_account = this.props.caSelected.control_account;
        assignation.deliverable = deliverables[0].deliverable;
        this.setState({
          deliverables: deliverables, 
          assignation:assignation,
          control_account: this.props.ca.control_account
        });
      }
    });
  }

  getValueCatalog(opts, id) 
  {
    let realValue = {};
    if(opts)
    {
      realValue = opts.find(o => o.value === id);
    }
    return realValue;
  }


  handleChangeSelection(val)
  {
    let assignation = this.state.assignation;
    assignation.deliverable = val.value;
    this.setState({assignation:assignation});
  }


  handleChange(event) 
  {
    const target = event.target;
    const value = target.value;
    const name = target.id? target.id:target.name;
    let assignation = this.state.assignation;
    assignation[name] = value;

    this.validateForm();

    this.setState({
      assignation: assignation,
    });
    this.validateForm();
  }



  validateForm = ()=>
  {
    let errores = {};
    let valido = true;
    let assignation = {
      // due_date:'',
      deliverable:''
    };
    //Validando atributos almenos ingresados
    for (const attribute in assignation) 
    {
      if (!validateField(this.state.assignation[attribute])) 
      {
        errores[attribute]= 'Please enter the required fields';
        valido = false;
      }
    }


    this.setState({
      errores: errores,
    });
    
    return valido;
  }

  resetState()
  {
    this.setState({
      assignation:{control_account: this.props.ca.control_account},
      errores:{},
      deliverables:[],
      buttonDisabled:false
    })
  }

  handleClose()
  {
    this.resetState();
    this.props.handleClose();
  }



  render() {
    
    return (
      <div>
        <Dialog
          open={this.props.open}
          onClose={this.handleClose}
          onEnter={this.onEnter}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">Assignation:</DialogTitle>

          
          <DialogContent>
            <Grid container spacing={24} style={{minWidth:"500px", minHeight:"250px"}}>
              <Grid item xs={12}>
                <InputLabel htmlFor="catalog" style={{marginRight:'10px'}}>Deliverable</InputLabel>
                <Select
                  required
                  id="deliverable"
                  name="deliverable"
                  value={this.getValueCatalog(this.state.deliverables,this.state.assignation.deliverable)}
                  onChange={this.handleChangeSelection}
                  options={this.state.deliverables}
                  styles={{control: (provided,state) => (this.state.errores.deliverable? {...provided,borderColor: 'red', } : provided)}}
                >
                </Select>
              </Grid>
            </Grid>

          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.selectDeiverables} disabled={this.state.buttonDisabled} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    ca: state.ca,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SelectDeliverable);



// WEBPACK FOOTER //
// ./src/features/ca/SelectDeliverable.js